import Icon from "./icons/Icon";
import "./Stopp.css";

/**
 * Die grosse STOPP-Flaeche in der Daumenzone (Host: STOPP, Mitspieler:
 * Buzzer). aus: gesperrt/wartend, dann mit icon + text statt "STOPP".
 * scharf: pulsierender Rand. gross: Mitspieler-Hoehe.
 * Alle weiteren Props gehen an das <button>.
 * @category spiel
 */
export function Stopp({ aus = false, scharf = false, gross = false, unterzeile, icon, text, children, ...rest }) {
  const klassen = ["stopp", gross && "gross", scharf && !aus && "scharf", aus && "aus"].filter(Boolean).join(" ");
  return (
    <button type="button" className={klassen} disabled={aus} {...rest}>
      {aus ? (
        <>
          {icon && (typeof icon === "string" ? <Icon name={icon} size={30} /> : icon)}
          <span className="stopp-text">{text}</span>
          {unterzeile && <small>{unterzeile}</small>}
        </>
      ) : (
        <>
          <span className="stopp-wort">{children || "STOPP"}</span>
          {unterzeile && <small>{unterzeile}</small>}
        </>
      )}
    </button>
  );
}

export default Stopp;
